import { getLabelBySlug } from '@/actions/login';
import { authorizedFetch } from '@/client';
import { useResource } from '@/hooks';
import { useEffect } from 'react';
import { createContext, useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

export const SessionContext = createContext({
  session: null,
  setSession: () => { },
  organization: null,
  setOrganization: () => { },
  user: null,
  theme: null,
  setTheme: () => {},
  setUser: () => {},
  label: null,
  artist: null,
  setArtist: () => {},
  person: null,
  setPerson: () => {},
  payee: null,
  setPayee: () => {},
  setLabel: () => {},
  hostname: 'localhost:3000',
  setHostname: () => {},
  role: null,
  setRole: (role) => {}
})

export function useLoadSession() {
  const { loadSession } = useContext(SessionContext)
  return loadSession
}

export function useSessionContext() {
  return useContext(SessionContext)
}

export function useLabel() {

  const { label, setLabel } = useSessionContext()
  
  const { labelId } = useParams()

  const load = () => {
    (async () => {
      let slug = labelId
      let data = null
      if (!slug) {
        slug = window.location.hostname
        data = await getLabelBySlug(slug)
      } else {
        data = await authorizedFetch('GET', `/label/${slug}`)
      }
      console.log("label", data)
      return data
    })().then(data => {
      setLabel(data)
    }).catch(e => {
      throw e
    })
  }

  useEffect(load, [labelId])

  useEffect(load, [])
 
  return label
}

export function useUser() {
  const { user } = useSessionContext()
  return user
}

export function useHostname() {
  const { hostname } = useSessionContext()
  return hostname
}

export function useSession() {
  const { session } = useSessionContext()
  return session
}

export function useRole() {
  const { role } = useSessionContext()
  return role
}
